export const RichEmbedThumbnail = () => (
  <svg
    viewBox="0 0 160 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
  >
    {/* Rich embed icon - Discord-style sidebar with content block */}
    {/* Blurple color bar */}
    <rect x="30" y="4" width="5" height="52" rx="2" fill="#5865f2" />
    {/* Embed body */}
    <rect x="35" y="4" width="95" height="52" rx="3" fill="#3949ab" />
    {/* Text lines inside */}
    <rect x="44" y="12" width="50" height="7" rx="2" fill="#7986cb" />
    <rect x="44" y="24" width="70" height="5" rx="1" fill="#5c6bc0" />
    <rect x="44" y="33" width="55" height="5" rx="1" fill="#5c6bc0" />
    <rect x="44" y="42" width="40" height="5" rx="1" fill="#5c6bc0" />
  </svg>
);
